import { Commodity } from '@enmon/commons/lib/shared';
import { Commodity as CommodityMessages } from 'components/Form/meter_details/messages';
import { MessageDescriptor } from 'react-intl';

export const COMMODITY_CONFIG = {
  [Commodity.Electricity]: {
    priority: 4,
    message: CommodityMessages[Commodity.Electricity],
  },
  [Commodity.NaturalGas]: {
    priority: 3,
    message: CommodityMessages[Commodity.NaturalGas],
  },
  [Commodity.Thermal]: {
    priority: 2,
    message: CommodityMessages[Commodity.Thermal],
  },
  [Commodity.Water]: {
    priority: 1,
    message: CommodityMessages[Commodity.Water],
  },
  [Commodity.Other]: {
    priority: 0,
    message: CommodityMessages[Commodity.Other],
  },
} satisfies Record<Commodity, { priority: number; message: MessageDescriptor }>;
